import React from 'react'
import { useMe } from '@/hooks/useMe'

interface AdminOnlyProps {
  children: React.ReactNode
}

const AdminOnly: React.FC<AdminOnlyProps> = ({ children }) => {
  const { user, isLoading } = useMe()

  // If still loading, don't render anything
  if (isLoading) {
    return null
  }

  // Only render children if user exists and has sys_admin role_type
  if (user && user.role_type === 'sys_admin') {
    return <>{children}</>
  }

  // Don't render anything for non-admin users
  return null
}

export default AdminOnly
